import script from "./ItemRewards.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemRewards.vue?vue&type=script&setup=true&lang=ts"

import "./ItemRewards.vue?vue&type=style&index=0&id=540f0f6c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540f0f6c"]])

export default __exports__